import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-align-center",
  templateUrl: "./med-icon-align-center.component.html",
})
export class MedIconAlignCenterComponent  extends SvgMixinComponent {}
